import type React from "react";

// Focuspunt (F5) — een handmatig gekozen punt per foto-URL ("x,y", fracties
// 0-1) dat bepaalt welk deel van de foto zichtbaar blijft wanneer CSS
// object-fit:cover een deel van de foto afsnijdt (bv. productkaarten).
// Zonder een ingesteld focuspunt blijft het standaard gedrag (midden) intact.
export function parseFocalPoint(raw: string | undefined): { x: number; y: number } | null {
  if (!raw) return null;
  const [xs, ys] = raw.split(",");
  const x = Number(xs);
  const y = Number(ys);
  if (!isFinite(x) || !isFinite(y)) return null;
  return { x: Math.min(1, Math.max(0, x)), y: Math.min(1, Math.max(0, y)) };
}

export function focalPointStyle(
  url: string | undefined,
  map: Record<string, string> | undefined
): React.CSSProperties {
  const point = url ? parseFocalPoint(map?.[url]) : null;
  if (!point) return {};
  return { objectPosition: `${Math.round(point.x * 100)}% ${Math.round(point.y * 100)}%` };
}
